module.exports = __webpack_public_path__ + "static/media/Logo.d17ae03e.png";